import React from 'react';
import {Helmet} from 'react-helmet';
import {useSelector} from 'react-redux';
import b_ from 'b_';

import {previewMeaningfulSelector} from 'client/common/components/survey-preview/components/preview';
import {HeaderButton} from 'client/common/components/header2/types';
import Header from 'client/common/components/header2/header2';
import Footer from 'client/common/components/footer';
import {Spin} from 'client/common/components/lego';
import {getTestBuckets} from 'client/common/store/selectors/user';
import {getSurvey} from 'client/common/store/selectors/survey';
import {sendRumCounter} from 'client/common/utils/rum';

import I18N from 'assets/i18n/root';

import {IArticleContentProps} from 'client/articles/types';

import {useArticleBySlug} from '../../hooks/articles';

const b = b_.with('article');

const i18n = I18N;

const headerButtons: HeaderButton[] = ['help', 'create', 'dialog', 'wallet'];

export default function ArticlePage() {
    const testBuckets = useSelector(getTestBuckets);
    const {slug = ''} = useSelector(getSurvey);

    sendRumCounter({
        page: 'quicksurvey.article',
        meaningfulPaintSelector: previewMeaningfulSelector,
        testBuckets
    });

    const {data, status} = useArticleBySlug(slug);

    return (
        <>
            <Helmet>
                <title>{i18n.articlesPage.title}</title>
            </Helmet>
            <Header className={b('header')} buttons={headerButtons} />
            <div className={b()}>
                {status === 'loading' ? (
                    <div className={b('spin_wrapper')}>
                        <Spin className={b('spin')} size='xs' view='default' progress />
                    </div>
                ) : (
                    <ArticleContent data={data} />
                )}
            </div>
            <Footer />
        </>
    );
}

function ArticleContent({data}: IArticleContentProps) {
    return (
        <>
            {data ? (
                <div className={b('body')}>
                    <h1 className={b('title')}>{data.approvedTitle}</h1>
                    <div dangerouslySetInnerHTML={{__html: data.approvedBody.html}} />
                </div>
            ) : (
                <p>{i18n.singleArticlePage.noArticleMessage}</p>
            )}
        </>
    );
}
